import { ChevronDown, Menu, X, Search, PlusCircle, Palette, BarChart3, TrendingUp, Zap, LogOut } from "lucide-react"
// import LinkIndex from "@/lib/linkIndex"
// import Account from "@/components/General/Navbar/Account"
import { useState, useEffect } from "react"
import Account from "~/components/General/Navbar/Account"

enum LinkIndex {
  MASTERCLASS = "/masterclass",
  BLOG = "/blog",
  ABOUT = "/about",
  FREE_RESOURCES = "/free-resources",
  SUPPORT = "/support",
  COMMUNITY = "https://community.selfpublishingtitans.com",
  MEDIA = "/media",
  AFFILIATEs = "/user/affiliate",
  LOGIN = "/login",
  TESTIMONIALS = "/testimonials",
  MY_ACCOUNT = "/me",
  REGISTER = "/register",
  ABOUT_US = "/about-us",
  HOT_NICHES = "/hot-niches-monthly",
  COVER_DESIGNER = "book-cover-creator",

  RESEARCH_TOOLS = "/research-tools",
  BOOK_CREATION = "/book-creation",
  BOOK_LISTING = "/book-listing",
  DESIGN_TOOLS = "/tools?categories=Design+Tools",
  GENERAL_KDP = "/general-kdp",
  TRAINING_TOOLS = "/training-tools",
  CONTACT_FORM = "/contact-form",

  CONTACT_US = "/contact-us",
  FAQS = "/faqs",
  TERMS_CONDITIONS = "/terms",
  PRIVACY_POLICY = "/terms/privacy",
  GDPR_POLICY = "/terms/gdpr",
  TRADEMARK = "/trademark",
  FEATURES = "/features",
  PRICING = "/pricing",
  TOOLS = "/tools",
  TOOLS_RESEARCH = "/tools?categories=Research+Tools",
  MENTORSHIP = "/mentorship",

  TITANS_PRO = "/titans-pro/on-site",
  BOOK_WRITER = "https://author.selfpublishingtitans.com",
  AUTHOR_WEBSITE_BUILDER = "https://selfpublishingtitans.com/author-links/home",
  KDP_COVER_TEMPLATE_GENERATOR = "/kdp-cover-template-generator",
  A_PLUS_CONTENT_TEMPLATE = "/A+-content-template-generator",
  LOW_CONTENT_BOOK_GENERATOR = "https://books.selfpublishingtitans.com/FREE-No-Content-Book-Creator-Software",
  ACTIVITY_BOOK_MAKER = "https://books.selfpublishingtitans.com/Activity-Book-Creator-Software/start-now?simple=true",
  PUZZLE_MAKER = "https://books.selfpublishingtitans.com/Puzzle-Maker-Software",
  COLORING_BOOKS = "https://editor.selfpublishingtitans.com/",
  BOOK_TITLE_CREATOR = "https://selfpublishingtitans.com/kdp-title-creator",
  BOOK_DESCRIPTION_CREATOR = "https://selfpublishingtitans.com/kdp-description-creator",
  WRITERS_AI_KIT = "/writers-ai-kit",

  SEVEN_BACKEND_KEYWORDS = "/7-backend-keywords-tool-amazon-kdp",
  KDP_BSR_ROYALITY_CALCULATOR = "/tools/KDP-BSR-Sales-Calculator",
  ACOS_Royalty_Calculator = "/tools/KDP-Royalty-Calculator",
  PEN_NAME_GENERATOR = "/tools/Pen-Name-Generator",
  QR_GEN = "/tools/QR-Code-Generator-for-KDP-Books",
  WORD_CLOUD = "/word-cloud",
  KEYWORD_TRACKER = "/titans-keyword-tracker",
  ASIN_TRACKER = "/titans-asin-tracker",
  BOOK_COVER_CREATOR = "/book-cover-creator",
  KDP_CATEGORY_FINDER = "/tools/KDP-Kindle-Category-Finder",
  DIGITAL_TITANS_DESIGNER = "https://design.selfpublishingtitans.com/",
  TITANS_QUICK_VIEW = "https://chromewebstore.google.com/detail/titans-pro-amazon-kdp-key/efdbcjcbgmadkmmcoojnncednmkelcli?authuser=3&hl=en",
  DEEP_VIEW = "/titans-deep-view",
  RETRO_VIEW = "/titans-retro-vision",

  TITLE_CREATOR = "/kdp-title-creator",
  DESCRIPTION_CREATOR = "/kdp-description-creator",
  TRADEMARK_CHECKER = "/kdp-trademark-checker",
  GUIDELINES_CHECKER = "/kdp-guidelines-checker",
  BOOK_DATA_TRANSLATOR = "/kdp-bookdata-translator",
  PRICE_CHECKER = "/kdp-price-checker",
  GRAMMAR_CHECKER = "/grammar-check",
  BOOK_PLANNER = "/book-planner",
  TEMPLATE_MEMBERSHIP_GROUP = "https://society.so/groups/@digitaltitanstemplates",
  ARC_REVIEW_MEMBERSHIP_GROUP = "https://society.so/groups/@arc-review-amazon-kdp",
  SALES_ARC = "/arc-reviews",
  SALES_TEMPLATES = "/templates",
  SALES_HOT_NICHE = "/hot-niches-sales",
  YOUTUBE_CHANNEL = "https://www.youtube.com/@SelfPublishingTitans",

  TOP_BEST_BOOKS = "/books/topbestbooks",
  KDP_POLICY_MONITOR = "/amazon-policy-monitor",
  PROFILE = "/profile",
}

const Link = (props: any) => {
  return <a {...props} />
}

const Image = (props: any) => {
  return <img {...props} />
}

import {
  ImageIcon,
  BookIcon,
  BookOpenText,
  BookCopy,
  BrushIcon,
  SearchIcon,
  TextSearch,
  ListCheck,
  SearchCheck,
  ListChecks,
  HandCoins,
  Banknote,
  LogsIcon,
  QrCodeIcon,
  PencilIcon,
  CloudIcon,
  GitCompareArrows,
  Youtube,
  TvMinimalPlay,
  ArrowUpNarrowWideIcon,
  ListTodoIcon,
  Languages,
  DollarSignIcon,
  PlusIcon,
  ChartAreaIcon,
  TriangleIcon,
  BookAIcon,
  TextIcon,
  HelpCircleIcon,
} from "lucide-react"

import { domains } from "~/constants"

interface NavbarV2Props {
  info?: any | false
  logout?: () => void
}

type TOption = {
  name: string
  Icon: React.ElementType
  tag?: string
  link: string
  new_tab?: boolean

  //   link:string
}

const CreateOptions: TOption[] = [
  // {
  //   name: "Book Cover",
  //   Icon: ImageIcon,
  //   link: domains.main + "/book-cover-creator",
  // },
  // {
  //   name: "A+ Content",
  //   Icon: ImageIcon,
  //   link: domains.main + "/A+-content-template-generator",
  // },
  {
    name: "Write Book",
    Icon: BookIcon,
    link: "https://author.selfpublishingtitans.com",
  },
  {
    name: "Puzzle Pages",
    Icon: BookOpenText,
    link: domains.books + "/Puzzle-Maker-Software",
  },
  {
    name: "Low Content Pages",
    Icon: BookCopy,
    link: domains.books + "/FREE-No-Content-Book-Creator-Software/start-now?simple=true",
  },
  {
    name: "Coloring Book",
    Icon: BrushIcon,
    link: "https://editor.selfpublishingtitans.com",
  },
  // {
  //   name: "Digital Titans Designer",
  //   Icon: BookAIcon,
  //   link: "https://design.selfpublishingtitans.com/",
  // },
]

const ResearchOptions: TOption[] = [
  {
    name: "Titans Pro",
    tag: "Search Suggestions",
    Icon: SearchIcon,
    new_tab: false,
    link: domains.main + "/titans-pro/on-site",
  },
  {
    name: "Deep View",
    tag: "Niche Analysis",
    Icon: TextSearch,
    link: domains.main + LinkIndex.DEEP_VIEW,
  },
  {
    name: "7 Backend Keywords",
    tag: "Book Listing SEO",
    Icon: ListCheck,
    link: domains.main + LinkIndex.SEVEN_BACKEND_KEYWORDS,
  },
  {
    name: "Retro View",
    tag: "Competetior Analysis",
    Icon: SearchCheck,
    link: domains.main + LinkIndex.RETRO_VIEW,
  },
  {
    name: "Quick View",
    tag: "Quick Analysis",
    Icon: ListChecks,
    new_tab: true,
    link: "https://chromewebstore.google.com/detail/titans-pro-amazon-kdp-key/efdbcjcbgmadkmmcoojnncednmkelcli?authuser=3&hl=en",
  },
]

const GeneralTools: TOption[] = [
  {
    name: "KDP BSR Sales Calculator",
    tag: "Estimate anyone's book sales",
    link: domains.main + LinkIndex.KDP_BSR_ROYALITY_CALCULATOR,
    Icon: HandCoins,
  },
  {
    name: "KDP Royalty Calculator",
    tag: "Calculate ad campaign profitability.",
    link: domains.main + LinkIndex.ACOS_Royalty_Calculator,
    Icon: Banknote,
  },
  {
    name: "KDP Category Finder",
    tag: "Find the best categories for your book and improve your SEO.",
    link: domains.main + LinkIndex.KDP_CATEGORY_FINDER,
    Icon: LogsIcon,
  },
  {
    name: "QR Code Generator",
    tag: "Create QR codes for your books",
    link: domains.main + LinkIndex.QR_GEN,
    Icon: QrCodeIcon,
  },
  {
    name: "Pen Name Generator",
    tag: "Create pen names for your books",
    link: domains.main + LinkIndex.PEN_NAME_GENERATOR,
    Icon: PencilIcon,
  },
  {
    name: "Word Cloud Generator",
    tag: "View most used words and keywords",
    link: domains.main + LinkIndex.WORD_CLOUD,
    Icon: CloudIcon,
  },
  {
    name: "Keyword Tracker",
    tag: "Track Keyword ranking for any product",
    link: domains.main + LinkIndex.KEYWORD_TRACKER,
    Icon: ChartAreaIcon,
  },
  {
    name: "ASIN Tracker",
    tag: "Monitor any products performance",
    link: domains.main + LinkIndex.ASIN_TRACKER,
    Icon: GitCompareArrows,
  },
  {
    name: "KDP Cover Template Generator",
    tag: "Create KDP Cover Templates",
    link: domains.main + LinkIndex.KDP_COVER_TEMPLATE_GENERATOR,
    Icon: BookIcon,
  },
]

const DesignTools: TOption[] = [
  {
    name: "KDP Cover Template Generator",
    tag: "Create KDP Cover Templates",
    link: domains.main + LinkIndex.KDP_COVER_TEMPLATE_GENERATOR,
    Icon: BookIcon,
  },
  {
    name: "Digital Titans Designer",
    tag: "Create Digital Titans Designer",
    link: LinkIndex.DIGITAL_TITANS_DESIGNER,
    Icon: BookIcon,
  },
  {
    name: "A+ Content Template Generator",
    tag: "Create A+ Content Templates",
    link: domains.main + LinkIndex.A_PLUS_CONTENT_TEMPLATE,
    Icon: BookIcon,
  },
]

const LearningTools: TOption[] = [
  {
    name: "Ask Question In Forum",
    Icon: HelpCircleIcon,
    link: "https://community.selfpublishingtitans.com/questions/ask",
  },
  {
    name: "KDP Masterclass",
    Icon: TvMinimalPlay,
    link: "https://www.selfpublishingtitans.com/masterclass",
  },
  {
    name: "Youtube Tutorials",
    Icon: Youtube,
    new_tab: true,
    link: "https://www.youtube.com/@SelfPublishingTitans",
  },
  {
    name: "Self Publishing Simplified",
    Icon: BookIcon,
    new_tab: true,
    link: "https://amzn.in/d/fyBNU9g",
  },
  {
    name: "Blog",
    Icon: TextIcon,
    link: domains.main + LinkIndex.BLOG,
  },
]

const BookListingTools: TOption[] = [
  {
    name: "KDP Title Creator",
    Icon: TvMinimalPlay,
    link: domains.main + LinkIndex.TITLE_CREATOR,
  },
  {
    name: "KDP Description Generator",
    Icon: ArrowUpNarrowWideIcon,
    link: domains.main + LinkIndex.DESCRIPTION_CREATOR,
  },
  {
    name: "KDP Trademark Violation Checker",
    Icon: TriangleIcon,
    link: domains.main + LinkIndex.TRADEMARK_CHECKER,
  },
  {
    name: "KDP Guidelines Checker",
    Icon: ListTodoIcon,
    link: domains.main + LinkIndex.GUIDELINES_CHECKER,
  },
  {
    name: "KDP Book Data Translator",
    Icon: Languages,
    link: domains.main + LinkIndex.BOOK_DATA_TRANSLATOR,
  },
  {
    name: "Book Price Suggestion Tool",
    Icon: DollarSignIcon,
    link: domains.main + LinkIndex.PRICE_CHECKER,
  },
  {
    link: domains.main + LinkIndex.GRAMMAR_CHECKER,
    name: "Grammar Checker",
    Icon: ListChecks,
  },
]

export { CreateOptions, ResearchOptions, GeneralTools, LearningTools, BookListingTools, DesignTools }

const startSections = [
  { title: "Research", options: ResearchOptions, withTags: true },
  { title: "Create", options: CreateOptions },
  { title: "Design", options: DesignTools },
  { title: "Optimize", options: BookListingTools },
  { title: "Grow", options: LearningTools },
  { title: "General", options: GeneralTools },
]

const navigationData = [
  // {
  //   title: 'Start',
  //   icon: <Zap className="w-4 h-4" />,
  //   items: [
  //     { label: 'Start Your KDP Journey', desc: 'A simple roadmap for new authors.' },
  //     { label: 'Watch a Quick Demo', desc: 'See how our publishing ecosystem works.' },
  //     { label: 'Find Profitable Ideas', desc: 'Learn how to validate demand before publishing.' },
  //     { label: 'Success Stories', desc: 'Real results from real authors.' },
  //     { label: 'Free Tools Library', desc: 'Start building with powerful free tools.' }
  //   ]
  // },
  {
    title: "Research",
    icon: <Search className="w-4 h-4" />,
    items: [
      {
        label: "Titans Pro Extension",
        desc: "Analyze demand and competition directly on Amazon.",
        highlight: true,
        href: domains.main + LinkIndex.TITANS_PRO,
      },
      {
        label: "Keyword Research Tool",
        desc: "Discover high-demand opportunities.",
        href: domains.main + LinkIndex.TITANS_PRO,
      },
      {
        label: "Reverse ASIN Lookup",
        desc: "See what top competitors are doing.",
        href: domains.main + LinkIndex.RETRO_VIEW,
      },
      {
        label: "Competitor Niche Research",
        desc: "Analyze entire niches before publishing.",
        href: domains.main + LinkIndex.DEEP_VIEW,
      },
      {
        label: "7 Backend Keywords Tool",
        desc: "Unlock hidden search visibility.",
        href: domains.main + LinkIndex.SEVEN_BACKEND_KEYWORDS,
      },
      {
        label: "Hot Niches (Monthly)",
        desc: "30 profitable niches delivered every month.",
        href: domains.main + LinkIndex.HOT_NICHES,
      },
    ],
  },
  {
    title: "Create",
    icon: <PlusCircle className="w-4 h-4" />,
    items: [
      {
        label: "Puzzle Book Maker",
        desc: "Word searches, crosswords, mazes & more.",
        highlight: true,
        href: LinkIndex.PUZZLE_MAKER,
      },
      {
        label: "Coloring Book Maker",
        desc: "Generate unique coloring interiors.",
        href: LinkIndex.COLORING_BOOKS,
      },
      {
        label: "Activity & Educational Tools",
        desc: "Sight words, math puzzles, workbooks.",
        href: LinkIndex.ACTIVITY_BOOK_MAKER,
      },
      {
        label: "Low & Medium Content",
        desc: "Planners, journals, notebooks, workbooks.",
        href: LinkIndex.PUZZLE_MAKER,
      },
      // { label: 'Children’s & Textbook Tools', desc: 'Structure professional layouts.', href: LinkIndex.LOW_CONTENT_BOOK_GENERATOR },
      // { label: 'AI Writing Assistant', desc: 'Draft outlines and content faster.', href: LinkIndex.PUZZLE_MAKER },
      // { label: 'Multi-Language Publishing', desc: 'Create books for global markets.', href: LinkIndex.PUZZLE_MAKER }
    ],
  },
  {
    title: "Design",
    icon: <Palette className="w-4 h-4" />,
    items: [
      {
        label: "Cover Design Tool",
        desc: "Create professional KDP-sized covers.",
        href: domains.main + LinkIndex.KDP_COVER_TEMPLATE_GENERATOR,
      },
      {
        label: "Interior Canvas Designer",
        desc: "Customize layouts and fine-tune formatting.",
        href: LinkIndex.DIGITAL_TITANS_DESIGNER,
      },
      {
        label: "A+ Content Designer",
        desc: "Build high-converting Amazon A+ modules.",
        href: domains.main + LinkIndex.A_PLUS_CONTENT_TEMPLATE,
      },
      // { label: 'KDP Formatting Tools', desc: 'Export print-ready files.', href: "" }
    ],
  },
  {
    title: "Optimize",
    icon: <BarChart3 className="w-4 h-4" />,
    items: [
      // { label: 'Titans AI Listing Analyzer', desc: 'Improve ranking and listing quality.', href: LinkIndex.PRICING },
      {
        label: "Title Creator",
        desc: "Generate SEO-optimized titles.",
        href: domains.main + LinkIndex.TITLE_CREATOR,
      },
      {
        label: "Book Description Generator",
        desc: "Craft persuasive descriptions instantly.",
        href: domains.main + LinkIndex.DESCRIPTION_CREATOR,
      },
      {
        label: "Trademark Checker",
        desc: "Check if your title is trademarked.",
        href: domains.main + LinkIndex.TRADEMARK_CHECKER,
      },
      {
        label: "Guidelines Checker",
        desc: "Check if your book meets Amazon's guidelines.",
        href: domains.main + LinkIndex.GUIDELINES_CHECKER,
      },
      {
        label: "Book Data Translator",
        desc: "Translate your book data to other languages.",
        href: domains.main + LinkIndex.BOOK_DATA_TRANSLATOR,
      },
      {
        label: "Price Checker",
        desc: "Check if your price is competitive.",
        href: domains.main + LinkIndex.PRICE_CHECKER,
      },
      {
        label: "Grammar Checker",
        desc: "Check your book for grammar errors.",
        href: domains.main + LinkIndex.GRAMMAR_CHECKER,
      },
      // { label: 'Backend Keyword Tool', desc: 'Maximize hidden search visibility.', href: LinkIndex.SEVEN_BACKEND_KEYWORDS }
    ],
  },
  {
    title: "Grow",
    icon: <TrendingUp className="w-4 h-4" />,
    items: [
      {
        label: "Author Website Builder",
        desc: "Build your author brand online.",
        href: LinkIndex.AUTHOR_WEBSITE_BUILDER,
      },
      {
        label: "ARC Review Service",
        desc: "Launch with compliant early reviews.",
        href: LinkIndex.ARC_REVIEW_MEMBERSHIP_GROUP,
      },
      {
        label: "KDP Masterclass",
        desc: "Step-by-step publishing training.",
        href: domains.main + LinkIndex.MASTERCLASS,
      },
      {
        label: "Private Mentorship",
        desc: "Scale faster with expert guidance.",
        href: domains.main + LinkIndex.MENTORSHIP,
      },
    ],
  },
]

const DropdownMenu = ({
  navItem,
  activeDropdown,
  setActiveDropdown,
}: {
  navItem: any
  activeDropdown: string | null
  setActiveDropdown: (activeDropdown: string | null) => void
}) => (
  <div
    className={`absolute dropdown-menu-custom top-full left-0 w-[320px] bg-white border border-gray-100 shadow-2xl rounded-xl p-4 transition-all duration-200 transform origin-top ${activeDropdown === navItem.title ? "opacity-100 scale-100" : "opacity-0 scale-95 pointer-events-none"
      }`}
    onMouseEnter={() => setActiveDropdown(navItem.title)}
    onMouseLeave={() => setActiveDropdown(null)}
  >
    <div className="space-y-1">
      {navItem.items.map((item: any, idx: number) => (
        <Link
          key={idx}
          href={item.href || "#"}
          className={`block p-3 rounded-lg transition-colors ${item.highlight ? "bg-indigo-50 border border-indigo-100" : "hover:bg-gray-50"
            }`}
        >
          <div className={`font-semibold text-sm ${item.highlight ? "text-indigo-700" : "text-gray-900"}`}>
            {item.label}
          </div>
          <div className="text-xs text-gray-500 mt-1">{item.desc}</div>
        </Link>
      ))}
    </div>
  </div>
)

function StartDropdownContent({
  activeDropdown,
  setActiveDropdown,
}: {
  activeDropdown: string | null
  setActiveDropdown: (activeDropdown: string | null) => void
}) {
  return (
    <div
      className={`absolute top-full left-0 min-w-[320px] w-max max-w-[1000px] max-h-[80vh] overflow-y-auto bg-white border border-gray-100 shadow-2xl rounded-xl p-4 transition-all duration-200 transform origin-top ${activeDropdown === "Start" ? "opacity-100 scale-100" : "opacity-0 scale-95 pointer-events-none"
        }`}
      onMouseEnter={() => setActiveDropdown("Start")}
      onMouseLeave={() => setActiveDropdown(null)}
    >
      <div className="space-y-6">
        {startSections.map((section, sectionIdx) => (
          <div key={sectionIdx}>
            <h4 className="text-xs font-bold text-indigo-600 capitalize tracking-widest mb-3">{section.title}</h4>
            <div className="grid grid-cols-4 gap-2">
              {section.options.map((option, optionIdx) => (
                <Link
                  key={optionIdx}
                  href={option.link}
                  target={option?.new_tab ? "_blank" : "_self"}
                  className="inline-flex items-center  text-wrap gap-2 px-3 py-2 rounded-lg transition-colors hover:bg-gray-50 border border-transparent hover:border-gray-100"
                >
                  <option.Icon className="w-4 h-4 text-indigo-600 shrink-0" />
                  <div className="min-w-0">
                    <div className="font-semibold text-sm text-gray-900 text-wrap">{option.name}</div>
                    {section.withTags && option.tag && (
                      <div className="text-xs text-gray-500 line-clamp-1 max-w-[140px]">{option.tag}</div>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const NavbarV2 = ({ info, logout }: NavbarV2Props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const isLoggedIn = info && typeof info !== "boolean"

  console.log({ activeDropdown, isMenuOpen, scrolled })

  return (
    <>
      <nav
        style={{
          zIndex: 1000,
        }}
        className={`absolute top-0 w-full  overflow-visible transition-all duration-300 ${scrolled ? "bg-white/95 backdrop-blur-md shadow-sm border-b py-2" : "bg-transparent py-3"
          }`}
      >
        <div className="max-w-full mx-auto px-4 md:px-6 flex items-center justify-between overflow-visible">
          <div className="flex items-center gap-8">
            <Link href="https://selfpublishingtitans.com" className="flex items-center gap-2 cursor-pointer group">
              {/* <div className="w-10 h-10 bg-indigo-600 rounded-lg flex items-center justify-center text-white font-bold text-xl group-hover:bg-indigo-700 transition-colors">S</div> */}
              <Image
                src={"https://assets1.selfpublishingtitans.com/images/logo_purple.png"}
                alt="Self Publishing Titans"
                width={100}
                height={100}
                className="w-auto h-8"
              />
              <span className="font-extrabold text-xl tracking-tight text-indigo-900">
                SELF PUBLISHING
                <span className="text-gray-400 ml-1">TITANS</span>
              </span>
            </Link>
          </div>

          <div className="hidden lg:flex items-center gap-1 overflow-visible">
            {navigationData.map((nav) => (
              <div
                key={nav.title}
                className="relative px-2 py-2 overflow-visible"
                onMouseEnter={() => setActiveDropdown(nav.title as any)}
                onMouseLeave={() => setActiveDropdown(null)}
              >
                <button
                  className={`flex items-center gap-1 text-[14px] font-bold transition-colors ${activeDropdown === nav.title ? "text-indigo-600" : "text-gray-600 hover:text-indigo-600"
                    }`}
                >
                  {nav.title}{" "}
                  <ChevronDown
                    className={`w-3 h-3 transition-transform ${activeDropdown === nav.title ? "rotate-180" : ""}`}
                  />
                </button>
                {nav.title === "Start" ? (
                  <StartDropdownContent activeDropdown={activeDropdown} setActiveDropdown={setActiveDropdown} />
                ) : (
                  <DropdownMenu navItem={nav} activeDropdown={activeDropdown} setActiveDropdown={setActiveDropdown} />
                )}
              </div>
            ))}
            <Link
              href={LinkIndex.FREE_RESOURCES}
              className="px-3 py-2 text-[14px] font-bold text-gray-600 hover:text-indigo-600 transition-colors"
            >
              Free
            </Link>
            <Link
              href={LinkIndex.PRICING}
              className="px-3 py-2 text-[14px] font-bold text-gray-600 hover:text-indigo-600 transition-colors"
            >
              Pricing
            </Link>
          </div>
          <div className="flex items-center gap-3">
            {isLoggedIn ? (
              <div className="">
                <Account info={info} logout={logout!} />
              </div>
            ) : (
              <>
                <Link
                  href={LinkIndex.LOGIN}
                  className="hidden sm:block text-sm font-semibold text-gray-600 hover:text-indigo-600 px-4"
                >
                  Login
                </Link>
                <Link href={LinkIndex.PRICING}>
                  <span className="bg-indigo-600 text-white px-6 py-2.5 rounded-full font-bold text-sm shadow-lg shadow-indigo-200 hover:bg-indigo-700 hover:-translate-y-0.5 transition-all active:scale-95 inline-block">
                    Get Titans Pro
                  </span>
                </Link>
              </>
            )}
            <button
              className="lg:hidden p-2 text-gray-600"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </nav>

      {/* --- MOBILE OVERLAY --- */}
      {isMenuOpen && (
        <div className="fixed inset-0 z-[60] bg-white p-6 overflow-y-auto">
          <div className="flex justify-between items-center mb-8">
            <span className="font-black text-xl text-indigo-900">TITANS MENU</span>
            <button onClick={() => setIsMenuOpen(false)} aria-label="Close menu">
              <X className="w-8 h-8" />
            </button>
          </div>

          {/* Mobile user section */}
          {isLoggedIn && (
            <div className="mb-8 p-4 bg-indigo-50 border border-indigo-100 rounded-xl">
              <div className="flex items-center justify-between gap-4">
                <Account isMobile info={info} logout={logout!} />
                <Link href="/profile" className="text-sm font-bold text-indigo-700">
                  My Account
                </Link>
              </div>
              <button
                onClick={() => {
                  logout?.()
                  setIsMenuOpen(false)
                }}
                className="mt-3 w-full flex items-center justify-center gap-2 py-3 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg font-semibold text-sm transition-colors"
              >
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </div>
          )}

          <div className="space-y-8">
            {/* Start: sections from startSections (Research, Create, Book Listing, etc.) */}
            <div>
              <h4 className="text-xs font-black text-indigo-600 uppercase tracking-widest mb-4 flex items-center gap-2">
                <Zap className="w-4 h-4" /> Start
              </h4>
              <div className="space-y-6">
                {startSections.map((section, sectionIdx) => (
                  <div key={sectionIdx}>
                    <h5 className="text-sm font-bold text-gray-800 mb-3">{section.title}</h5>
                    <div className="flex flex-wrap gap-2">
                      {section.options.map((option, optionIdx) => (
                        <Link
                          key={optionIdx}
                          href={option.link}
                          target={option?.new_tab ? "_blank" : "_self"}
                          onClick={() => setIsMenuOpen(false)}
                          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-50 hover:bg-gray-100 border border-gray-100"
                        >
                          <option.Icon className="w-4 h-4 text-indigo-600 shrink-0" />
                          <div>
                            <div className="font-bold text-sm text-gray-900 whitespace-nowrap">{option.name}</div>
                            {section.withTags && option.tag && (
                              <div className="text-xs text-gray-500 line-clamp-1">{option.tag}</div>
                            )}
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Rest of nav: Research, Create, Design, Optimize, Grow */}
            {navigationData.slice(1).map((nav, i) => (
              <div key={nav.title}>
                <h4 className="text-xs font-black text-indigo-600 uppercase tracking-widest mb-4 flex items-center gap-2">
                  {nav.icon} {nav.title}
                </h4>
                <div className="grid gap-3">
                  {nav.items.map((item, idx) => (
                    <Link
                      key={idx}
                      href={item.href || LinkIndex.FREE_RESOURCES}
                      onClick={() => setIsMenuOpen(false)}
                      className="block py-2 border-b border-gray-50"
                    >
                      <div className="font-bold text-gray-900">{item.label}</div>
                      <div className="text-xs text-gray-500">{item.desc}</div>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
            <div className="pt-4 space-y-4">
              {!isLoggedIn && (
                <>
                  <Link
                    href={LinkIndex.PRICING}
                    onClick={() => setIsMenuOpen(false)}
                    className="block w-full py-4 bg-indigo-600 text-white rounded-xl font-bold text-center"
                  >
                    Get Titans Pro
                  </Link>
                  <Link
                    href={LinkIndex.LOGIN}
                    onClick={() => setIsMenuOpen(false)}
                    className="block w-full py-4 bg-gray-50 text-gray-900 rounded-xl font-bold text-center"
                  >
                    Login
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default NavbarV2
